__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "merchNotificationMFE";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "child-scope": {
			register("@design-systems/canvas-ui", "8.0.8", function() { return Promise.all([__webpack_require__.e(580), __webpack_require__.e(409), __webpack_require__.e(283), __webpack_require__.e(205)]).then(function() { return function() { return __webpack_require__(2409); }; }); });
		}
		break;
		case "default": {
			register("@praxis/analytics", "26.1.1", function() { return __webpack_require__.e(793).then(function() { return function() { return __webpack_require__(6793); }; }); });
			register("@tanstack/react-query", "5.90.11", function() { return Promise.all([__webpack_require__.e(663), __webpack_require__.e(283), __webpack_require__.e(17)]).then(function() { return function() { return __webpack_require__(6663); }; }); });
			register("html-react-parser", "5.2.10", function() { return Promise.all([__webpack_require__.e(355), __webpack_require__.e(283)]).then(function() { return function() { return __webpack_require__(9355); }; }); });
			register("merch-telemetry-core", "1.0.0", function() { return Promise.all([__webpack_require__.e(442), __webpack_require__.e(529), __webpack_require__.e(392)]).then(function() { return function() { return __webpack_require__(529); }; }); });
			register("merch-telemetry-react", "1.0.2", function() { return Promise.all([__webpack_require__.e(283), __webpack_require__.e(230), __webpack_require__.e(725)]).then(function() { return function() { return __webpack_require__(1106); }; }); });
			register("react-dom", "18.3.1", function() { return Promise.all([__webpack_require__.e(108), __webpack_require__.e(283)]).then(function() { return function() { return __webpack_require__(8108); }; }); });
			register("react-window-infinite-loader", "1.0.10", function() { return Promise.all([__webpack_require__.e(283), __webpack_require__.e(555)]).then(function() { return function() { return __webpack_require__(5555); }; }); });
			register("react-window", "1.8.11", function() { return Promise.all([__webpack_require__.e(667), __webpack_require__.e(283)]).then(function() { return function() { return __webpack_require__(3667); }; }); });
			register("react", "18.3.1", function() { return __webpack_require__.e(685).then(function() { return function() { return __webpack_require__(6685); }; }); });
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};